import React, { useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import CompanyLegal from '../components/CompanyLegal';
import { GENERAL, SERVICES, TERMS_VERSION, EFFECTIVE_DATE, numbered } from '../data/serviceTerms';

/*
 * /terms                -> shared terms for all marketing & web services
 * /terms/:serviceId     -> one page per service: its own terms first, then the
 *                          shared terms, so a quote only ever links one URL.
 */
function ServiceTerms() {
  const { serviceId } = useParams();
  const service = serviceId ? SERVICES[serviceId] : null;

  useEffect(() => {
    document.title = service
      ? `${service.name} Terms — Moneli Automation Inc.`
      : 'Service Terms — Moneli Automation Inc.';
  }, [service]);

  if (serviceId && !service) return <Navigate to="/terms" replace />;

  const sections = numbered(service ? [...service.sections, ...GENERAL] : GENERAL);
  const others = Object.entries(SERVICES).filter(([id]) => id !== serviceId);

  return (
    <CompanyLegal
      slug={service ? `terms-${serviceId}` : 'terms'}
      crumb={service ? `${service.short} terms` : 'Service terms'}
      title={service ? <>{service.name} <em>terms</em></> : <>Service <em>terms</em></>}
      lead={service ? service.lead : 'The terms that apply to every SEO, website and digital marketing service from Moneli Automation.'}
      meta={[
        { label: 'Version', value: TERMS_VERSION },
        { label: 'Effective date', value: EFFECTIVE_DATE },
      ]}
      intro={
        <p>
          These terms apply when you accept a Moneli quote for this service, by signing it, accepting it by
          email, or paying its deposit. Your quote sets the scope and price.{' '}
          Other services: {others.map(([id, s], i) => (
            <React.Fragment key={id}>{i > 0 && ' · '}<Link to={`/terms/${id}`}>{s.short}</Link></React.Fragment>
          ))}{service && <> · <Link to="/terms">shared terms only</Link></>}.
        </p>
      }
      sections={sections}
    />
  );
}

export default ServiceTerms;
